<template>
  <HeaderUser v-if="isLoggedIn" />
  <HeaderGuest v-else />
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import HeaderUser from '@/components/layout/header/HeaderUser.vue';
import HeaderGuest from '@/components/layout/header/HeaderGuest.vue';
import { useUserStore } from '@/store/useUserStore';
const userStore = useUserStore();
const { isLoggedIn } = storeToRefs(userStore);
</script>
